import { Tooltip } from '@mui/material';

export const LabelWithTooltip = (label, tooltipText) => (
  <Tooltip title={tooltipText} placement="right">
    <span>{label}</span>
  </Tooltip>
);

